import { NgOptimizedImage } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { ChatMessage, ChatMessageContent } from '@models/chat-message.interface';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { IconComponent } from '@shared/icon/icon.component';
import { LevelNewComponent } from '@shared/level-new/level-new.component';
import { NamePipe } from '@shared/pipes/name.pipe';

@Component({
  selector: 'app-chat-big-win',
  templateUrl: './chat-big-win.component.html',
  styleUrls: ['./chat-big-win.component.scss'],
  imports: [NgOptimizedImage, LevelNewComponent, IconComponent, CurrencyComponent, NamePipe],
})
export class ChatBigWinComponent implements OnChanges {
  @Input() event: ChatMessage;
  content: ChatMessageContent;

  ngOnChanges(): void {
    if (this.event && this.event.content) {
      this.content = this.event.content as ChatMessageContent;
    }
  }
}
